module.exports = __webpack_public_path__ + "static/media/FEDERALBNK_F1.75a720de.txt";